
// Herko
export const environment = {
  production: false,
  Ambiente: 3,
  appName: 'MPX',
  appVersion: '1.14.2',
  AppToken: 'F066B5D5-F351-4AF3-B18A-A7099ED445D7',
  LoginURL: 'https://apps.ximplify.mx/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts